import React from 'react';
import styled from 'styled-components';
import { activityShimmer, shimmerText } from './activityShimmer';

/**
 * Inline placeholder shown while the model is generating (or editing) an image.
 * Mounted on the `image_generating` SSE event and removed when the real image
 * `file` arrives (it replaces this) or the turn ends without one. Reuses the
 * shared chat shimmer idiom (`activityShimmer` keyframes + `shimmerText`) so it
 * reads as the same "activity running" look as the rest of the chat.
 */

const Wrap = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
  margin: 6px 0;
  max-width: 100%;
`;

// Image-sized shimmering square — same gradient-sweep animation as the activity
// labels, applied to a surface instead of text.
const ShimmerSquare = styled.div`
  width: 288px;
  height: 288px;
  max-width: 100%;
  border-radius: 12px;
  background: linear-gradient(
    90deg,
    ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)')} 25%,
    ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.11)' : 'rgba(0,0,0,0.09)')} 37%,
    ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)')} 63%
  );
  background-size: 200% 100%;
  animation: ${activityShimmer} 4.2s linear infinite;
`;

const Caption = styled.span`
  font-size: 0.82rem;
  font-weight: 500;
  font-family: 'Sora', 'Lexend', sans-serif;
  ${shimmerText}
`;

interface ImageGeneratingSkeletonProps {
  hasInput?: boolean;
}

const ImageGeneratingSkeleton: React.FC<ImageGeneratingSkeletonProps> = ({ hasInput }) => (
  <Wrap>
    <ShimmerSquare aria-label={hasInput ? 'Editando imagem' : 'Gerando imagem'} />
    <Caption>{hasInput ? 'Editando imagem…' : 'Gerando imagem…'}</Caption>
  </Wrap>
);

export default ImageGeneratingSkeleton;
